import { DocumentTitle } from 'library/head';
import { IFrameCameraDetailViewer } from 'modules/dashboard/features/iframe-integration-viewer';
import useIFrameCameraImages from 'modules/dashboard/features/iframe-integration-viewer/hooks/useIFrameCameraImages';
import useIFrameIntegrationViewerData from 'modules/dashboard/features/iframe-integration-viewer/hooks/useIFrameIntegrationViewerData';
import PagePreloader from 'modules/shared/components/loaders/PagePreloader';
import {
    IllustrationView,
    NoImagesIllustration,
    SomethingWentWrongIllustration,
} from 'modules/shared/features/illustration';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const IFrameIntegrationViewerPage = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('t');

    const iFrameIntegrationViewerData = useIFrameIntegrationViewerData(token);

    const {
        isInitialLoading,
        isLoading: isImagesQueryLoading,
        images,
        selectedImage,
        setSelectedImage,
        selectedDate,
        setSelectedDate,
        startDate,
        endDate,
        refetch,
    } = useIFrameCameraImages(token);

    useEffect(() => {
        if (!iFrameIntegrationViewerData.integration) return;

        const intervalInMilliseconds = +iFrameIntegrationViewerData.integration.refreshInterval * 60 * 1000; // refreshInterval is in minutes

        setInterval(() => {
            console.log('Refetching...');
            // Reset date to refetch the latest images
            setSelectedDate(null);

            // Refetch images query
            refetch();
        }, intervalInMilliseconds);
    }, [iFrameIntegrationViewerData.integration, refetch, setSelectedDate]);

    if (iFrameIntegrationViewerData.isLoading || isInitialLoading) return <PagePreloader />;

    if (iFrameIntegrationViewerData.error)
        return (
            <IllustrationView
                className="justify-center h-screen"
                illustration={<SomethingWentWrongIllustration />}
                title="Link Expired"
                message="This link has expired."
            />
        );

    const { camera, project, integration } = iFrameIntegrationViewerData;

    return (
        <>
            <DocumentTitle>
                {camera.name} - {project.name}
            </DocumentTitle>

            <>
                {camera.hasImages ? (
                    <IFrameCameraDetailViewer
                        camera={camera}
                        project={project}
                        integration={integration}
                        images={images}
                        selectedImage={selectedImage}
                        onSelectedImageChange={setSelectedImage}
                        selectedDate={selectedDate}
                        onSelectedDateChange={setSelectedDate}
                        startDate={startDate}
                        endDate={endDate}
                        isLoading={isImagesQueryLoading}
                    />
                ) : (
                    <IllustrationView
                        className="justify-center h-screen"
                        illustration={<NoImagesIllustration />}
                        title="No Images yet"
                        message="No images for this camera found."
                    />
                )}
            </>
        </>
    );
};

export default IFrameIntegrationViewerPage;
